import React from 'react'

import { Card } from '@softwaredev_cegeka/stix-core'

class FormLayout extends React.Component {
    render() {
        return (
            <Card {...this.props}>
                <Card.Body>{this.props.children}</Card.Body>
            </Card>
        )
    }
}

export default FormLayout
